import DocumentPostback from './DocumentPostback';
export default DocumentPostback;
